import clsx from 'clsx';

interface FlyerLandscapeSingleSidedProps {
  className?: string;
}

const FlyerLandscapeSingleSided: React.FC<FlyerLandscapeSingleSidedProps> = ({ className }) => {
	return (
		<svg
			className={clsx('flyer-landscape-single-sided', className)}
			fill="none"
			height="116"
			viewBox="0 0 144 116"
			width="144"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8 0.5H136C140.142 0.5 143.5 3.85786 143.5 8V108C143.5 112.142 140.142 115.5 136 115.5H8C3.85787 115.5 0.5 112.142 0.5 108V8L0.509766 7.61426C0.710535 3.65139 3.98724 0.5 8 0.5Z"
				fill="white"
			/>
			<path
				d="M8 0.5H136C140.142 0.5 143.5 3.85786 143.5 8V108C143.5 112.142 140.142 115.5 136 115.5H8C3.85787 115.5 0.5 112.142 0.5 108V8L0.509766 7.61426C0.710535 3.65139 3.98724 0.5 8 0.5Z"
				stroke="#D1D2D4"
			/>
			<path d="M8 8H136V92C136 100.837 128.837 108 120 108H8V8Z" fill="#D1E7DD" />
			<g clipPath="url(#clip0_12824_14025)">
				<path
					d="M120 92C126.126 93.3271 129.62 93.4553 136 92V108H120C120.84 101.628 120.909 98.1167 120 92Z"
					fill="#A3CFBB"
				/>
			</g>
			<path
				d="M77.25 67L63 67C61.3431 67 60 65.6569 60 64L60 52C60 50.3431 61.3431 49 63 49L81 49C82.6569 49 84 50.3431 84 52L84 60.25L77.25 67ZM77.25 62.5C77.25 61.2574 78.2574 60.25 79.5 60.25L82.5 60.25L82.5 52C82.5 51.1716 81.8284 50.5 81 50.5L63 50.5C62.1716 50.5 61.5 51.1716 61.5 52L61.5 64C61.5 64.8284 62.1716 65.5 63 65.5L77.25 65.5L77.25 62.5Z"
				fill="#75B798"
			/>
			<defs>
				<clipPath id="clip0_12824_14025">
					<path d="M120 92H136C136 100.837 128.837 108 120 108V92Z" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};


export default FlyerLandscapeSingleSided;
